import { render, staticRenderFns } from "./examPlan.vue?vue&type=template&id=f5f16e10&scoped=true"
import script from "./examPlan.vue?vue&type=script&lang=js"
export * from "./examPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f16e10",
  null
  
)

export default component.exports